import { Injectable } from '@angular/core';

export interface AnalyticsEvent {
  event: string;
  click_type?: string;
  click_action?: string;
  type?: string;
  label?: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private ensureDataLayer() {
    if (!(window as any).dataLayer) {
      (window as any).dataLayer = [];
    }
  }

  private logEvent(event: AnalyticsEvent) {
    const color: Record<string, string> = {
      click: 'color: #007acc',
      page_view: 'color: #28a745',
      default: 'color: #6c757d'
    };


    const style = color[event.event] || color['default'];

    console.log(`%c[Analytics] ${event.event.toUpperCase()}`, style, event);
  }

  track(event: AnalyticsEvent) {
    this.ensureDataLayer();
    (window as any).dataLayer.push(event);
    this.logEvent(event);
  }

  trackClick(action: string, label?: string, extra?: Record<string, any>) {
    this.track({
      event: 'click',
      click_type: 'button',
      click_action: action,
      label,
      ...extra
    });
  }

  trackPageView(pageName: string) {
    this.track({
      event: 'page_view',
      type: pageName
    });
  }

  trackCustom(eventName: string, payload: Record<string, any>) {
    this.track({
      event: eventName,
      ...payload
    });
  }
}
